export default __webpack_public_path__ + "static/media/KZ.T.11.0264 black.3911e062.svg";